/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable react/jsx-pascal-case */
import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import {
  Header,
  Footer,
  Link_Box1,
  Search_Box1,
  Loading,
} from '../../components/index'
import { WebApi } from '../../api/web'

const ServiceSingle = () => {
  let { slug } = useParams()
  const [lawyers, setLawyers] = useState(null)
  const [valueSearch, setValueSearch] = useState('')

  useEffect(() => {
    getLawyers()
  }, [])
 

  const getLawyers = async () => {
    await WebApi.lawyers({
      services: [slug],
    })
      .then((res) => {
        setLawyers(res.data.data.searchLawyers.lawyers)
      })
      .catch((err) => {})
  }
  return (
    <>
      <Header title='خدمات آنلاین' />
      <div className='container'>
        <div className='template-pages'>
          <div className='single-service-text'>
            اگر شما یک طراح هستین و یا با طراحی های گرافیکی سروکار دارید به متن
            های برخورده اید که با نام لورم ایپسوم شناخته می‌شوند. لورم ایپسوم یا
            طرح‌نما (به انگلیسی: Lorem ipsum) متنی ساختگی و بدون معنی است که
            برای امتحان فونت و یا پر کردن فضا در یک طراحی گرافیکی و یا صنعت چاپ
            استفاده میشود. طراحان وب و گرافیک از این متن برای پرکردن صفحه و
            ارائه شکل کلی طرح استفاده می‌کنند
          </div>
          <Search_Box1
            placeholder='نام وکیل، شهر استان'
            setState={setValueSearch}
          />
          {lawyers ? (
            lawyers
              .filter((data) => {
                return (
                  data.fname
                    .toLowerCase()
                    .includes(valueSearch.toLowerCase()) ||
                  data.lname
                    .toLowerCase()
                    .includes(valueSearch.toLowerCase()) ||
                  data.mobile.toLowerCase().includes(valueSearch.toLowerCase())
                )
              })
              .map((lawyer) => (
                <Link_Box1
                  name={`${lawyer.fname} ${lawyer.lname}`}
                  job='وکیل پایه یک دادگستری'
                  fileNumber='3394837592'
                  avatar={lawyer.avatar}
                  link={`/detail-lawyer/${lawyer._id}`}
                />
              ))
          ) : (
            <Loading />
          )}
        </div>
      </div>
      <Footer />
    </>
  )
}
export default ServiceSingle
